var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 15l-2.727-2.727L16.948 22.6V0h-3.9v22.6L2.727 12.273 0 15l15 15z","fill":"#fff","opacity":".4"}));
}

Arrow.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = Arrow;

Arrow.default = Arrow;
